import { getPath } from '#lib/utils.js'

export function t(path: string) {
  return getPath(translations, path, path)
}

export function pluralize(num: number, singular: string, plural: string) {
  if (num === 1) {
    return `${num} ${singular}`
  } else {
    return `${num} ${plural}`
  }
}

export function plural(num: number, singular: string, plural: string) {
  if (num === 1) {
    return singular
  } else {
    return plural
  }
}

export function formatPercentage(num: number) {
  return `${num * 100} %`
}

const translations = {
  ADMIN: 'Administrator:in',
  NORMAL: 'Mitarbeiter:in',
  TICKET_TAKER: 'Einlass',
  OUTLET: 'Vorverkaufsstelle',
  STRIPE: 'Stripe',
  'STRIPE.card': 'Kredit- oder Debitkarte',
  TRANSFER: 'Überweisung',
  FREE: 'Kostenlos',
  VOUCHER: 'Gutschein',
  REBOOKING: 'Umbuchung',
  PAYPAL: 'PayPal',
  VR_PAYMENT: 'VR Payment',
  INVOICE: 'Rechnung',
  DEBIT: 'Lastschrift',
  EMAIL: 'per E-Mail',
  POST: 'Postversand',
  PICKUP: 'Abholung',
  SHIPPED: 'Verschickt',
  RETURNED: 'Zurückgegeben',
  NOT_SHIPPED: 'Nicht verschickt',
  PAID: 'Bezahlt',
  UNPAID: 'Nicht bezahlt',
  OVERDUE: 'Überfällig',
  REFUNDED: 'Rückerstattet',
  MARKED_PAID: 'Als bezahlt markiert',
  MARKED_UNPAID: 'Als nicht bezahlt markiert',
  MARKED_REFUNDED: 'Als rückerstattet markiert',
  MARKED_SHIPPED: 'Als verschickt markiert',
  MARKED_NOT_SHIPPED: 'Als nicht verschickt markiert',
  MARKED_RETURNED: 'Als zurückgegeben markiert',
  MARKED_CANCELLED: 'Storniert',
  RESENT_MAIL: 'E-Mail erneut verschickt',
  UPDATED_SECRET_NOTE: 'Notiz geändert',
  SENT_INFO_MAIL: 'Mitteilung geschickt',
  UPDATED_DATA: 'Bestelldaten geändert',
  UPDATED_EMAIL: 'E-Mail-Adresse geändert',
  CANCELLED: 'Storniert',
  VALID: 'Gültig',
  PRESENT: 'Vorhanden',
  EMPTY: 'Leer',
  checkoutProgress: {
    cart: 'Warenkorb',
    shipping: 'Lieferung',
    payment: 'Zahlungsart',
    confirm: 'Bestätigen',
  },
  SALES_TAX: {
    '0': 'Umsatzsteuerbefreit',
    '5': 'Alle Preise inkl. 5 % USt',
    '7': 'Alle Preise inkl. 7 % USt',
    '16': 'Alle Preise inkl. 16 % USt',
    '19': 'Alle Preise inkl. 19 % USt',
  },
  FEE: {
    SHIPPING: 'Versandkosten',
    PAYMENT: 'Zahlungsmittelentgelt',
    OUTLET: 'Vorverkaufsgebühr',
    VOUCHER: 'Servicegebühr für Gutscheine',
  },
  DISCOUNT_CODE: {
    INFINITE: 'Unbegrenzt',
    ONCE: 'Einmalig',
  },
  EVERYBODY: 'Für alle',
  NOBODY: 'Niemand',
  PRESENTER: 'Veranstalter',
  PRESENTER_AND_OUTLET: 'Veranstalter und Vorverkaufsstelle',
  SHORT: {
    EMAIL: 'E-Mail',
    OUTLET: 'VVK',
    PICKUP: 'Abholung',
    POST: 'Post',
    DEBIT: 'Lastschrift',
    FREE: 'Kostenlos',
    INVOICE: 'Rechnung',
    PAYPAL: 'PayPal',
    REBOOKING: 'Umbuchung',
    STRIPE: 'Stripe',
    TRANSFER: 'Überweisung',
    VOUCHER: 'Gutschein',
    VR_PAYMENT: 'VR Payment',
  },
  NEW_PRICE: 'Neuer Preis',
  NEW_RELATIVE_PRICE: 'Prozentuale Änderung',

  NOT_AVAILABLE: 'Keine Tickets verfügbar',
  AVAILABLE_SOON: 'Demnächst im Vorverkauf',
  SOLD_OUT: 'Ausverkauft',
  REST_AT_BOX_OFFICE: 'Restkarten an der Abendkasse',

  automation: {
    publish: 'Veröffentlichen',
    unpublish: 'Veröffentlichung aufheben',
    startSale: 'Verkauf starten',
    stopSale: 'Verkauf stoppen',
  },
} as const
